export default class Form {
  constructor(element) {
    this.element = element;
    this.init();
  }
  init() {}
}
